import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import AuthPage from "./pages/AuthPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="*" element={
          <ClerkAuthProvider>
            <Routes>
              <Route path="/admin" element={<Admin />} />
              <Route path="/sign-in/*" element={<AuthPage mode="sign-in" />} />
              <Route path="/sign-up/*" element={<AuthPage mode="sign-up" />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </ClerkAuthProvider>
        } />
      </Routes>
      <Toaster position="top-center" offset={96} richColors />
    </BrowserRouter>
  );
}

export default App;
